
import { Mapper } from '../../../../../base/utils/mapper';
import { PlanBusinessModel } from '../../../../../domain/models/configuration/company/plan-business.model';
import { PlanBusinessEntity } from '../../entities/company/plan-business.entity';


export class PlanBusinessImplementationRepositoryMapper extends Mapper<
  PlanBusinessEntity,
  PlanBusinessModel
> {
  mapFrom(param: PlanBusinessEntity): PlanBusinessModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: PlanBusinessModel): PlanBusinessEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
